<template>
  <el-container  class="app-container" direction="vertical">
    <Header></Header>
    <el-container class="app-contant">
      <Sider></Sider>
      <el-main class="app-main" v-if="isRouterAlive">
        <el-card
          class="app-card"
          :body-style="cardBodyStyle"
          shadow="never"
          v-loading="$store.state.loading"
          ref="appCard"
          element-loading-text="加载中"
        >
          <transition name="fade-transform" mode="out-in">
            <keep-alive>
              <router-view class="page-content" :style="{'min-height':minHeight+'px'}" v-if="$route.meta && $route.meta.keepAlive">
              </router-view>
            </keep-alive>
          </transition>
          <transition name="fade-transform" mode="out-in">
            <router-view class="page-content" :style="{'min-height':minHeight+'px'}" v-if="!$route.meta.keepAlive"></router-view>
          </transition>
        </el-card>
      </el-main>
    </el-container>

  </el-container>
</template>

<script>
import {
  mapState, mapActions,
} from 'vuex';
import Header from './Header/index';
import Sider from './Sider';
import { version } from '../../../package.json';

import menuConfig from '@/config/menuConfig';
import Breadcrumb from './Header/Breadcrumb';
import TagsView from './TagsView';

export default {
  components: {
    Header,
    Sider,
    Breadcrumb,
    TagsView,
  },

  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      loading: false,
      contentHeight: 0,
      isRouterAlive: true,
      version,
      minHeight: 0,
    };
  },

  beforeCreate() {
    this.$store.dispatch('InitUserData').then((data) => {
      this.$store.dispatch('corporation/InitCorporation', { corporationId: data.corporationId });
      this.$store.dispatch('project/InitProjects');
      this.$store.dispatch('device/GetDeviceTypeOptions');
      this.$store.dispatch('structure/GetStructureTypeOptions');
      this.$store.dispatch('measuringAttribute/GetMeasuringAttributeTypeOptions');
      this.$store.dispatch('device/GetCollectorTypeOptions');
      this.$store.dispatch('ChangeTheme', data.theme);
    }).catch(() => {
      this.$message.success('登录信息出错');
      this.$router.push('/sign');
    });
  },
  created() {
    this.changeBreadcrumb(this.$route);
    this.minHeight = window.innerHeight - 100;
    this.$bus.$on('RESIZE_WINDOW', () => {
      this.minHeight = window.innerHeight - 100;
    });
  },
  beforeDestroy() {
    this.$bus.$off('RESIZE_WINDOW');
  },
  computed: {
    ...mapState('corporation', ['corporation']),
    cardBodyStyle() {
      return {
        padding: this.$route.meta.hideCardBodyPadding ? 0 : '20px',
      };
    },
  },
  watch: {
    $route() {
      this.changeBreadcrumb(this.$route);
    },
  },
  methods: {
    ...mapActions(['setBreadcrumbItems']),
    changeBreadcrumb(route) {
      let oneLevelMenu = {};
      let twoLevelMenu = {};
      menuConfig.forEach((menu) => {
        if (menu.children) {
          const menuItem = menu.children.find(item => item.path === route.path);
          if (menuItem) {
            oneLevelMenu = menu;
            twoLevelMenu = menuItem;
          }
        } else if (menu.path === route.path) {
          oneLevelMenu = menu;
        }
      });
      console.log(1);
      this.setBreadcrumbItems([oneLevelMenu, twoLevelMenu]);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },

};

</script>

<style lang="scss">
@import '../../assets/theme/_themes.scss';
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all .5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.el-menu--popup {
  // 项目滚动条
  /*max-height: 440px;*/
  /*overflow-y: auto;*/
}
.app-container{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .app-contant{
    overflow: hidden;
  }
  .app-main{
    padding: 0;
    position: relative;
    &-header{
      background-color: #fff;
      margin: 0 -20px 20px!important;
      overflow: hidden;
      .el-alert{
        margin: 5px 0;
        padding: 0 10px;
        line-height: 30px;
        &__description{
          margin-top: 0;
        }
        &__closebtn{
          top:0;
          height: 30px;
          line-height:30px;
        }
      }
    }

    .app-card{
      flex:1;
      box-sizing: border-box;
      overflow: hidden;
      overflow-y: auto;
      min-height: calc(100%-60px);
      border: none;
      border-radius: 0;
      @include background_color('background-color-base');
    }

    .page-content {
      @include background_color('background-color-box');
      border: none;
    }

  }

  .app-footer{
    font-size: 12px;
    padding-top: 15px;
    color: #666;
    .fl{
      float: left;
    }
    .fr{
      float: right;
    }
  }
}
</style>
